<script setup lang="ts">
/**
 * Root component de l'app GGVie consulting standalone (SD-3875).
 *
 * Hérite de la sandbox originelle mais débarrassé du bandeau d'impersonation
 * et des dépendances spécifiques à l'admin (l'app cible client final).
 */
import MaintenanceToast from '@ggvie-consulting/maintenance/MaintenanceToast.vue'
import { useScrollbarWidth } from '@ggvie-consulting/sidebar/useScrollbarWidth'

// Expose `--scrollbar-width` en CSS variable globale pour aligner
// les bords droits des contrôles fixes vs zones scrollables (sidebar).
useScrollbarWidth()
</script>

<template>
  <div class="app-root">
    <RouterView />
    <MaintenanceToast />
  </div>
</template>

<style>
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans,
    Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #111827;
  background-color: #f9fafb;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  cursor: pointer;
  border: none;
  background: none;
  font-family: inherit;
  font-size: inherit;
}

input {
  font-family: inherit;
  font-size: inherit;
}

/* Probe utilisé par useScrollbarWidth pour mesurer la scrollbar custom. */
.gg-sidebar-scrollbar-probe {
  scrollbar-width: thin;
}
.gg-sidebar-scrollbar-probe::-webkit-scrollbar {
  width: 8px;
}
</style>

<style scoped>
.app-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
